/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SettingValue,
  SettingValue$inboundSchema,
  SettingValue$Outbound,
  SettingValue$outboundSchema,
} from "./settingvalue.js";

/**
 * Type of the value
 */
export const SettingKind = {
  Number: "number",
  Boolean: "boolean",
  Enum: "enum",
  Schedule: "schedule",
  Sequence: "sequence",
} as const;
/**
 * Type of the value
 */
export type SettingKind = OpenEnum<typeof SettingKind>;

/**
 * A setting
 */
export type Setting = {
  /**
   * Measurable or changeable aspect of a device.
   */
  desiredValue?: SettingValue | undefined;
  /**
   * Type of the value
   */
  kind: SettingKind;
  /**
   * Setting ID
   */
  settingId: string;
  /**
   * Measurable or changeable aspect of a device.
   */
  value: SettingValue;
};

/** @internal */
export const SettingKind$inboundSchema: z.ZodType<
  SettingKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(SettingKind);
/** @internal */
export const SettingKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  SettingKind
> = openEnums.outboundSchema(SettingKind);

/** @internal */
export const Setting$inboundSchema: z.ZodType<Setting, z.ZodTypeDef, unknown> =
  z.object({
    desired_value: types.optional(SettingValue$inboundSchema),
    kind: SettingKind$inboundSchema,
    setting_id: types.string(),
    value: SettingValue$inboundSchema,
  }).transform((v) => {
    return remap$(v, {
      "desired_value": "desiredValue",
      "setting_id": "settingId",
    });
  });
/** @internal */
export type Setting$Outbound = {
  desired_value?: SettingValue$Outbound | undefined;
  kind: string;
  setting_id: string;
  value: SettingValue$Outbound;
};

/** @internal */
export const Setting$outboundSchema: z.ZodType<
  Setting$Outbound,
  z.ZodTypeDef,
  Setting
> = z.object({
  desiredValue: SettingValue$outboundSchema.optional(),
  kind: SettingKind$outboundSchema,
  settingId: z.string(),
  value: SettingValue$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    desiredValue: "desired_value",
    settingId: "setting_id",
  });
});

export function settingToJSON(setting: Setting): string {
  return JSON.stringify(Setting$outboundSchema.parse(setting));
}
export function settingFromJSON(
  jsonString: string,
): SafeParseResult<Setting, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Setting$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Setting' from JSON`,
  );
}
